module.exports = __webpack_public_path__ + "static/media/W19-0096_56_Burger_Mobile_767x845_EN.d138b93e.jpg";